import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from "@material-ui/styles";
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import {Button} from "@material-ui/core";
import Modal from 'react-bootstrap/Modal';
import { ImageRewrite, getFormatedCurrency, getFormatedNumber } from 'components/util';
import NoPropertyPhoto from 'img/nd/no-property-photo.png';
import '../scss/_comparepropertyND.scss';
import * as listingActions from 'actions/listings';


class PropertiesCompare extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false 
        };
        this.onDeleteCompareClicked = this.onDeleteCompareClicked.bind(this);
        this.format = this.format.bind(this);
        this.collapse = this.collapse.bind(this);
    }

    mapping = {
        MN: 'MLS No.',
        TLC: 'TLC',
        LP: 'List Price',
        FA: 'Address'
    }

    collapsed = {
        LA: 'Sqft', // collapsible
        GR: 'Garages',
        YR: 'Year Built',
        PT: 'Architecture'
    }

    onDeleteCompareClicked = (listingId) => {
        this.props.listingActions.removeListing('compare', listingId);
    }

    format = (key, value) => {
        switch (key) {
            case 'LP':
            case 'TLC':
                return (<div className='compare-highlight'>{getFormatedCurrency(value)}</div>);
            case 'MN':
                return (<div className='compare-highlight'>{ value }</div>);
            case 'FA':
                var breaks = value.split('\n');
                var ret = breaks.map((line, i) => {
                    return (<p key={i}>{line}</p>);
                })
                return ret;
            case 'LA':
                return getFormatedNumber(value);
            default:
                return value;
        }
    }

    collapse = () => {
        this.setState({collapsed: !this.state.collapsed})
    }

    render() {
        const { properties } = this.props;
        const mapping = this.mapping;
        const collapsed = this.collapsed;
        
        return (
            <div>
                <div className="row mg-tp-10">    
                    <div className="col-md-12">
                        <div className="compare-mb-table">
                            <table className="compare-house" cellPadding="0" cellSpacing="0">
                                <tbody>
                                    <tr>
                                        <th></th>
                                        {
                                            properties.map((property, index) => {
                                                var imgSrc
                                                if (!property.Photos || !property.Photos.length) {
                                                    if (property.INDXR) {
                                                        imgSrc = ImageRewrite(property.INDXR.split('|')[0], true);
                                                    }
                                                    else {
                                                        imgSrc = NoPropertyPhoto;
                                                    }
                                                }
                                                else {
                                                    imgSrc = ImageRewrite(property.Photos[0], true);
                                                }
                                                var FA = `${property.SA} ${property.CT}, ${property.ST} ${property.PC}`;
                                                return (<td key={index}>
                                                    <div key={index}>
                                                        <Link alt="Property Detail Link" aria-label="Property Detail Link" onClick={() => this.props.closeDialog()} to={`${this.props.purlPrefix.url}/propertydetail/` + property.Id + '/' + (property.SA ? property.SA.split(' ').join('-') : property.MN) + (property.CT ? '_' + property.CT.split(' ').join('-') : '') + (property.ST ? '_' + property.ST.split(' ').join('-') : '') + (property.PC ? '_' + property.PC.split(' ').join('-') : '')} >
                                                            <img src={imgSrc} alt={FA} className="compare-img" />
                                                        </Link>
                                                    </div>
                                                </td>)
                                            })}
                                    </tr>
                                    {Object.keys(mapping).map((key, i) => {
                                        return (
                                            <tr key={"tr-" + i}>
                                                <th key={"th-" + i}>{mapping[key]}</th>
                                                {properties.map((property, index) => {
                                                    var FA = `${property.SA}\n${property.CT}, ${property.ST}\n${property.PC}`;
                                                    var propertyWithAddress = { ...property, FA };
                                                    return <td  key={"td-" + index}>{this.format(key, propertyWithAddress[key])}</td>
                                                })}
                                            </tr>
                                        );
                                    }, this)}
                                    {/* <tr><th><i className={this.state.collapsed ? "fa fa-arrow-down" : "fa fa-arrow-up"} onClick={this.collapse}></i></th>{properties.map((property, index) => { return <td></td> })}</tr> */}
                                    {Object.keys(collapsed).map((key, i) => {
                                        return (
                                            <tr key={"tr-" + i} className={this.state.collapsed ? "compare-collapsed": "compare-collapsible" }>
                                                <th key={"th-" + i}>{collapsed[key]}</th>
                                                {properties.map((property, index) => {
                                                    return <td  key={"th-" + index}>{this.format(key, property[key])}</td>
                                                })}
                                            </tr>
                                        );
                                    }, this)}
                                    <tr>
                                        <th>
                                        </th>
                                        {properties.map((property, index) =>
                                            <td key={"td-" + index}>
                                                <Button id="pop_remove_bt" onClick={() => this.onDeleteCompareClicked(property.Id)} variant="contained" className="theme-btn">Remove</Button>
                                            </td>
                                        )}
                                    </tr>
                                </tbody>
                            </table>
                        </div>      
                    </div>    
                </div>
            </div>            
        )
    }
}

export class PropertiesCompareAlert extends React.Component {
    constructor(props) {
        super(props);
        this.onDeleteCompareClicked = this.onDeleteCompareClicked.bind(this);
        this.state = {
            isCompareModalOpen: false,
        }
    }

    showCompareModal = (_properties) => {
        const { classes} = this.props;
        let propListings = this.props.listings
        let compareListings = _properties.listings.reduce((obj, item) => Object.assign(obj, {[item.Id]: item}) ,{});
        let allListings = {...propListings, ...compareListings }

        return (
            <Modal
                show={this.state.isCompareModalOpen}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => this.setState({ isCompareModalOpen: false})}
            >
                <Typography className={(classes && classes.comparelist) || ""} component={'span'} variant="body2">
                    <Modal.Header className="text-center" closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            <Typography className={(classes && classes.typographytitle) || ""} variant="h2">
                                Property Comparison
                            </Typography>
                        </Modal.Title>
                    </Modal.Header> 
                    <Modal.Body>
                        <div><PropertiesCompare properties={_properties.ids.map(id => allListings[id])} listingActions={this.props.listingActions} purlPrefix={this.props.purlPrefix} /></div>
                    </Modal.Body>
                </Typography>
            </Modal>
        )
    }
    
    onDeleteCompareClicked = (listingId) => {
        this.props.listingActions.removeListing('compare', listingId);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.isCompareModalOpen && JSON.stringify(this.props.properties) !== JSON.stringify(nextProps.properties)) {
            this.setState({ isCompareModalOpen: true });
        }
    }    

    render() {
        const { properties, purlPrefix, classes } = this.props;        
        
        if (properties && properties.ids.length){
            let propListings = this.props.listings
            let compareListings = properties.listings.reduce((obj, item) => Object.assign(obj, {[item.Id]: item}) ,{});
            let allListings = {...propListings, ...compareListings }
            let compareListingsObjs = properties.ids.map(id => allListings[id]);
            return (
                <Typography className={(classes && classes.comparelistoption) || ""} component={'span'} variant="body2">
                    <div className="prop-compare-list">
                        <div className="compare-alert">
                            <div className="compare-content">
                                <div className="compare-header"> You have {properties.ids.length} properties to compare 
                                    <div className="compare-button compare-open">
                                        <span id="compare_arrow" className="material-icons" onClick={() => {this.setState({isCompareModalOpen: true})}}  /* onClick={() => this.openCompareDialog(properties)} */>navigate_next</span>
                                    </div>
                                </div>
                                {
                                    compareListingsObjs.map((property, index) => {
                                        var imgSrc
                                        if (!property.Photos || !property.Photos.length) {
                                            if (property.INDXR)
                                                imgSrc = ImageRewrite(property.INDXR.split('|')[0], true);
                                            else
                                                imgSrc = NoPropertyPhoto;
                                        }
                                        else 
                                            imgSrc = ImageRewrite(property.Photos[0], true);
                                        var FA = `${property.SA} ${property.CT}, ${property.ST} ${property.PC}`;
                                        return (
                                            <div key={index} className="compare-property-box">
                                                <Link alt="Property Detail Link" aria-label="Property Detail Link" to={`${purlPrefix.url}/propertydetail/` + property.Id + '/' + (property.SA ? property.SA.split(' ').join('-') : property.MN) + (property.CT ? '_' + property.CT.split(' ').join('-') : '') + (property.ST ? '_' + property.ST.split(' ').join('-') : '') + (property.PC ? '_' + property.PC.split(' ').join('-') : '')} >
                                                    <img src={ imgSrc } alt={FA} className="compare-img" />
                                                </Link>
                                                <div className="compare-delete">
                                                    <span id="close_property_bt" className="material-icons"onClick={() => this.onDeleteCompareClicked(property.Id)}>close</span>
                                                </div>
                                            </div>
                                        )
                                    })}
                            </div>
                            {this.state.isCompareModalOpen && this.showCompareModal(properties)}
                        </div>
                    </div>
                </Typography>                
            );
        }
        return (null)
    }    
}

const styles = theme => ({
    typographytitle: {
        fontWeight:'normal',
        lineHeight:'normal',
        letterSpacing:'inherit',
        color:theme.palette.primary.title,
        '&.MuiTypography-h1': {
            fontWeight:'normal',
            lineHeight:'normal',
            letterSpacing:'inherit',
        },
        '&.MuiTypography-h2': {
            fontWeight:'normal',
            lineHeight:'normal',
            letterSpacing:'inherit',
        } 
    },

    typographybutton:{
        background: theme.palette.secondary.main,
        color: theme.palette.secondary.text,
        '&.MuiButton-contained': {
          boxShadow:'inherit',
          letterSpacing:'inherit',
          lineHeight:'normal',
          textTransform:'none',
        }, 
        '&.MuiButton-root': {
            minWidth:'inherit',
            fontWeight:'inherit',
        },
        '&:hover': {
            background: theme.palette.secondary.dark,
            color: theme.palette.secondary.text,
        },
        '&:focus': {
            background: theme.palette.secondary.dark,
            color: theme.palette.secondary.text,
        },
    },

    comparelistoption: {
        '& .prop-compare-list': {
            '& .compare-content': {
                color:theme.palette.primary.text,
                '& .compare-header': {
                    color:theme.palette.primary.text,
                    '& .compare-button': {
                        background: theme.palette.secondary.main,
                    }
                },
                '& .prop-compare-remove': {
                    background: theme.palette.secondary.main,
                }
            }
        }
    },

    comparelist: {
        '& .compare-house': {
            color: theme.palette.primary.text,
            '& tbody': {
                '& tr': {
                    '& td': {
                        color: theme.palette.primary.text,
                        '& .compare-highlight': {
                            color: theme.palette.primary.text,
                        },
                        '& .compare-img': {
                            borderColor:theme.palette.primary.border,
                            borderWidth:1,
                            borderStyle:'solid',                
                        }
                    },
                    '& th': {
                        color: theme.palette.default.dark,
                    }
                }
            },
            
        },
        '& .theme-btn': {
            background: theme.palette.secondary.main,
            color: theme.palette.secondary.text,
            lineHeight:'normal',
            '&.MuiButton-contained': {
                boxShadow:'inherit',
                letterSpacing:'inherit',
                lineHeight:'normal',
                textTransform:'none',
            }, 
            '&.MuiButton-root': {
                minWidth:'inherit',
                fontWeight:'inherit',
            },
            '&:hover': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.text,
            },
            '&:focus': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.text,
            },
        },
    }
});

const mapStateToProps = (state, props) => ({
    properties: state.listings.compare,
    listings: state.entities.listings,
    purlPrefix: state.session.purlPrefix || { url: ''}
})

const mapDispatchToProps = dispatch => ({
    listingActions: bindActionCreators(listingActions, dispatch)
})

/* export default connect(mapStateToProps, mapDispatchToProps)(PropertiesCompareAlert); */

export default  withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(PropertiesCompareAlert, PropertiesCompare));